<!-- Header -->
<app-header #HeaderEl class="header d-block position-fixed fixed-top top-0 start-0 "></app-header>
<!-- Header ends -->

<!-- Sidebar -->
<app-sidebar #SidebarEl class="sidebar-wrap"></app-sidebar>
<!-- Sidebar ends -->

<!-- Begin page content -->
<main class="main mainheight position-relative" #mainContainer>
    <router-outlet class="h-100"></router-outlet>

    <!-- page level footer-->
    <!-- <div class="px-3">
        <app-page-footer class="container footer-page bg-radial-gradient-theme my-4 py-5 d-block"></app-page-footer>
    </div> -->
    <!-- page level footer ends -->
</main>
<!-- Page content ends-->

<!-- footer -->
<!-- <app-footer #FooterEl class="footer text-white mt-auto z-index-1 position-relative d-block"></app-footer> -->
<!-- footer ends -->


<!-- Rightbar -->
<div class="rightbar-wrap" #RightbarEl>
    <div class="rightbar">

        <!-- notifications window -->
        <!-- <app-notification class="notificationwindow d-block d-none h-100 overflow-y-auto" id="notificationwindow"></app-notification> -->
        <!-- notifications window ends -->

    </div>
</div>
<!-- Rightbar ends -->


<!-- footer sticky bottom -->
<footer class="footer-sticky d-block d-md-none d-xl-none d-lg-none " #FooterStickyEl>
    <div class="container">
        <ul class="nav nav-pills nav-justified">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/forms/list']" routerLinkActive="active">
                    <span>
                        <i class="nav-icon bi bi-house"></i>
                        <span class="nav-text">{{'forms' | translate }}</span>
                    </span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/forms/reports']" routerLinkActive="active">
                    <span>
                        <i class="nav-icon bi bi-binoculars"></i>
                        <span class="nav-text">{{'reports' | translate}}</span>
                    </span>
                </a>
            </li>
            <li class="nav-item centerbutton">
                <a class="nav-link" [routerLink]="['/forms/list']" routerLinkActive="active">
                    <span class="bg-radial-gradient-theme">
                        <!-- <i class="bi bi-palette size-22"></i> -->
                        <span class="material-icons">dashboard</span>
                    </span>
                </a>
            </li>
           
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['profile']" routerLinkActive="active">
                    <span>
                        <i class="nav-icon bi bi-person"></i>
                        <span class="nav-text">{{ 'profile' | translate}}</span>
                    </span>
                </a>
            </li>

            <li class="nav-item">
                <!-- <a class="nav-link" routerLink="/pages/app/email" routerLinkActive="active">
                    <span>
                        <i class="nav-icon bi bi-bag"></i>
                        <span class="nav-text">Email</span>
                    </span>
                </a> -->
            </li>

        </ul>
    </div>
</footer>
<!-- footer sticky bottom ends -->